import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Get locations for a project */
export async function getLocations(projectId) {
  const { data } = await axios.get(`${API}/locations?project_id=${projectId}`);
  return data;
}

/** Create a new location */
export async function createLocation(locationData) {
  const { data } = await axios.post(`${API}/locations`, locationData);
  return data;
}

/** Update a location — accepts full location data object */
export async function updateLocation(locationId, locationData) {
  const { data } = await axios.put(`${API}/locations/${locationId}`, locationData);
  return data;
}

/** Auto-detect locations from script */
export async function detectLocations(projectId) {
  const { data } = await axios.post(`${API}/locations/${projectId}/detect`, {});
  return data;
}

/** Get 3D design data for a location */
export async function get3DDesign(locationId) {
  const { data } = await axios.get(`${API}/locations/${locationId}/3d-design`);
  return data;
}

/** Save 3D design state — accepts full design data object */
export async function save3DDesign(locationId, designData) {
  const { data } = await axios.post(`${API}/locations/${locationId}/3d-design/save`, designData);
  return data;
}

/** Generate 3D environment (AI) */
export async function generate3DDesign(locationId, genData) {
  const { data } = await axios.post(`${API}/locations/${locationId}/3d-design/generate`, genData);
  return data;
}

/** Lock 3D design for production */
export async function lock3DDesign(locationId) {
  const { data } = await axios.post(`${API}/locations/${locationId}/3d-design/lock`, {});
  return data;
}

/** Upload a reference image for 3D design */
export async function upload3DReference(locationId, referenceData) {
  const { data } = await axios.post(`${API}/locations/${locationId}/3d-design/upload-reference`, referenceData);
  return data;
}

/** Generate reference renders for a location */
export async function generateReference(locationId, genData) {
  const { data } = await axios.post(`${API}/locations/${locationId}/generate-reference`, genData);
  return data;
}
